import React, { memo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Container } from "../../../components";
import { Permission } from "../../../utils";
import { IMAGES } from "../../../configs";
import { ModalFormSalary, TableSalary } from "../components";
import {
  getContractsByEmployee,
  getProfileStaff,
  setModalAddSalary
} from "../../../redux/actions";

interface Props {
  employeeId: string;
}

const Salary = ({ employeeId }: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProfileStaff(employeeId));
    dispatch(getContractsByEmployee(employeeId));
  }, [dispatch, employeeId]);

  const permission = {
    create: Permission("employee-others-edit")
  };

  return (
    <>
      <Container scroll>
        <div className="page-contracts-list">
          <TableSalary employee={employeeId} />
        </div>
      </Container>
      {permission.create ? (
        <Container withMaxWidth flex className="company-division-footer-button">
          <div style={{ position: "relative", width: "100%" }}>
            <div style={{ position: "absolute", right: 0 }}>
              <Button
                className="company-button"
                onPress={() => {
                  dispatch(setModalAddSalary(true));
                }}
              >
                <img src={IMAGES.floatingPlusButton} alt="create" />
              </Button>
            </div>
          </div>
        </Container>
      ) : null}
      <ModalFormSalary employee={employeeId} isUpdate={false} />
    </>
  );
};

export default memo(Salary);
